module.exports = __webpack_public_path__ + "img/logo.255604b8.png";